import {Email} from "../Input/Email.js";
import { RoleDropDown } from "../Input/RoleDropdown.js";
import { Stack, Button } from "@mui/material";
import {writeEmailToFirebase} from "../API/apis.js"
import { useInputStore } from "Store"

const MailingList = () => {
  const who_are_you = useInputStore(state => state.who_are_you)
  const email = useInputStore(state => state.email)
  const handleJoin = () => {
    // Handle the join button clic
    writeEmailToFirebase(email, {who_are_you})

  }
  return (
    <>
     <Stack
        direction='column'
        spacing={3}
        useFlexGap
        sx={{ 
          height: '100%', 
          flexGrow: 1, 
          flexWrap: 'wrap', 
          justifyContent: 'center',
          alignContent: 'center',
        }}
      >
    <Email/>
     <RoleDropDown/>
     <Button onClick={handleJoin}
     
     >Join</Button>
     </Stack>
     </>
  );
}

export default MailingList;
